import mod from "../lib/index.js";

export default mod["default"];
